<div
  *ngIf="content"
  class="trip-search w-full"
  id="mach-core-trip-search-container"
>
  <!-- Back Link -->
  <a
    *ngIf="content.displayBackLink"
    href="javascript:void(0)"
    class="trip-search__back-link mb-20 link link-sm link-inline"
    (click)="displayTripDetails()"
    [attr.aria-label]="content.backToUpcomingTripLabel"
    id="mach-core-trip-search-back-link"
  >
    <span class="link-arrow-icon-collapsed"></span>
    {{ content.backToUpcomingTripLabel }}
  </a>

  <section
    *ngIf="hasFormErrors"
    class="trip-search__error-section flex justify-center tablet:mb-[24px]"
    id="mach-core-trip-search-error-section"
  >
    <idp-error-message
      [errorMessage]="'To continue, please correct the'"
      [cntError]="currentErrorCount"
      (firstInvalidFieldFocusEvent)="focusFirstInvalidFieldHandler()"
    ></idp-error-message>
  </section>

  <form
    #tripWidgetSearchForm
    class="trip-search__form flex flex-col gap-16 w-full laptop:flex-row laptop:items-start"
    [action]="content.formAttributes.formAction"
    [formGroup]="content.formGroup"
    method="POST"
    id="mach-core-trip-search-form"
  >
    <div
      class="trip-search__content grid grid-cols-1 gap-[8px] laptop:gap-12 ultrawide:gap-16 px-16 py-16 rounded-03 bg-surface-02 shadow-01 tablet:grid-cols-2 laptop:flex laptop:flex-row laptop:px-0 laptop:py-0 laptop:rounded-none laptop:bg-transparent laptop:shadow-none"
      id="mach-core-trip-search-content"
    >
      <div
        class="trip-search__dropdown-wrapper w-[311px] tablet:w-[346px] laptop:w-[222px] ultrawide:w-[232.5px]"
      >
        <button
          [id]="content.dropdownId"
          class="dropdown w-full !border-stroke-01"
          type="button"
        ></button>
      </div>

      <ng-container *ngFor="let searchType of content.dataList; let i = index">
        <ng-container *ngIf="searchType.value === content.currentType">
          <div
            class="trip-search__field relative w-[311px] tablet:w-[346px] laptop:flex laptop:flex-col laptop:min-h-[80px] laptop:w-[184px] ultrawide:w-[232.5px]"
            id="mach-core-trip-search-type-{{ i }}"
          >
            <input
              type="text"
              class="single-line-input w-icon peer !border-stroke-01"
              [id]="searchType.value"
              [name]="searchType.value"
              [placeholder]="searchType.placeHolder"
              [formControlName]="searchType.value"
              [attr.aria-label]="searchType.title"
              [attr.aria-invalid]="
                shouldShowError(searchType.value) &&
                !focusedFields[searchType.value]
              "
              autocomplete="off"
              (focus)="focusedFields[searchType.value] = true"
              (blur)="focusedFields[searchType.value] = false"
            />
            <label class="static-title">{{ searchType.title }}</label>
            <svg
              *ngIf="
                searchType.helpIcon === 'true' &&
                searchType.popup?.title &&
                searchType.popup?.description
              "
              class="trip-search__help-icon absolute right-4 !top-[40%] cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              (click)="openDialog(searchType.popup)"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="11.25" fill="#0066CC" />
              <path
                d="M12.4129 7.46709C12.4129 8.21878 12.9265 8.71129 13.7047 8.71129C14.5582 8.71129 15.2778 8.08955 15.2778 7.24699C15.2778 6.49603 14.7266 6 13.968 6C13.1347 6 12.4129 6.66156 12.4129 7.46709Z"
                fill="white"
              />
              <path
                d="M9.28418 16.9905C9.28418 17.6898 9.7608 18 10.4407 18C12.3587 18 14.5754 15.7281 14.5754 15.1951C14.5754 15.0323 14.4432 14.9212 14.3491 14.9212C14.241 14.9212 14.0048 15.178 13.7245 15.4829C13.3141 15.9291 12.809 16.4784 12.4708 16.4784C12.319 16.4784 12.2437 16.3492 12.2437 16.2234C12.2437 15.9644 12.4067 15.5752 12.5226 15.2987L12.5656 15.1951L13.9325 11.6245C14.6146 9.84933 13.7422 9.3701 12.9265 9.3701C11.8286 9.3701 10.8406 9.90102 10.082 10.5997L10.0109 10.6677C9.70514 10.9599 9 11.6337 9 11.9347C9 12.0465 9.11206 12.1736 9.24664 12.1736C9.38763 12.1736 9.62476 11.9036 9.90399 11.5858C10.3033 11.1312 10.7886 10.5787 11.2015 10.5787C11.3513 10.5787 11.5226 10.7449 11.3895 11.0761L10.0631 14.2995C9.92944 14.6104 9.28418 16.1137 9.28418 16.9905Z"
                fill="white"
              />
            </svg>

            <div
              *ngIf="
                content.submitClicked &&
                content.formGroup.controls[searchType.value].errors
              "
              class="trip-search__field-errors mt-[8px] laptop:min-h-[16px]"
            >
              <p
                *ngIf="
                  content.formGroup.controls[searchType.value].errors?.[
                    'required'
                  ]
                "
                class="trip-search__error-message text-caption-medium text-alert"
              >
                {{ searchType.mandatoryError }}
              </p>
              <p
                *ngIf="
                  content.formGroup.controls[searchType.value].errors?.[
                    'pattern'
                  ]
                "
                class="trip-search__error-message text-caption-medium text-alert"
              >
                {{ searchType.patternError }}
              </p>
            </div>

            <input
              type="hidden"
              [name]="content.hiddenInputs.tab"
              [value]="content.currentType"
            />
            <input
              type="hidden"
              [name]="content.hiddenInputs.searchOption"
              [value]="searchType.using"
            />
          </div>
        </ng-container>
      </ng-container>

      <!-- Name Fields -->
      <ng-container *ngFor="let field of content.nameList; let i = index">
        <div
          class="trip-search__field trip-search__field--name relative w-[311px] tablet:w-[346px] laptop:flex laptop:flex-col laptop:min-h-[80px] laptop:w-[164.5px] ultrawide:w-[232.5px]"
          id="mach-core-trip-search-name-field-{{ i }}"
        >
          <input
            type="text"
            class="single-line-input peer !border-stroke-01"
            [id]="field.value"
            [name]="field.value"
            placeholder=" "
            [formControlName]="field.value"
            [attr.aria-label]="field.title"
            [attr.aria-invalid]="
              shouldShowError(field.value) && !focusedFields[field.value]
            "
            autocomplete="off"
            (focus)="focusedFields[field.value] = true"
            (blur)="focusedFields[field.value] = false"
          />
          <label class="floating-title">{{ field.title }}</label>

          <div
            *ngIf="
              content.submitClicked &&
              content.formGroup.controls[field.value].errors
            "
            class="trip-search__field-errors mt-[8px] laptop:min-h-[16px]"
          >
            <p
              *ngIf="
                content.formGroup.controls[field.value].errors?.['required']
              "
              class="trip-search__error-message text-caption-medium text-alert"
            >
              {{ field.mandatoryError }}
            </p>
            <p
              *ngIf="
                content.formGroup.controls[field.value].errors?.['pattern']
              "
              class="trip-search__error-message text-caption-medium text-alert"
            >
              {{ field.patternError }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="trip-search__actions">
      <button
        #searchButton
        type="submit"
        class="trip-search__submit-button button button-primary button-lg px-32 w-[343px] h-16 tablet:w-[736px] laptop:w-[145px] ultrawide:w-[154px]"
        data-acdl-name="my trips:search"
        data-acdl-action="header:my trips:search"
        data-acdl-page-section="header:my trips:search"
        (click)="onSubmit(); analyticsEvent.emit(searchButton)"
        aria-label="Search"
        id="mach-core-trip-search-submit"
      >
        {{ content.searchCTA }}
      </button>
    </div>
  </form>
</div>
